export default __webpack_public_path__ + "static/personalized-797420c509d52bdaa10cd3e17edfada8.png";